import { createContext, useContext } from 'react';

/**
 * Context para compartir funciones del dialer con componentes hijos
 */
const DialerContext = createContext({
  handleRedialFromAgentCalls: null
});

export const DialerProvider = DialerContext.Provider;

export const useDialer = () => {
  const context = useContext(DialerContext);
  return context;
};

export default DialerContext;
